export const MENU = {
  id: 1,
  displayName: "Menu",
  icon: "fa-light fa-objects-column",
  displayOrder: 1,
  description: "",
};
export const CATEGORY = {
  id: 2,
  displayName: "Category",
  icon: "fa-light fa-objects-column",
  displayOrder: 2,
  description: "",
};
export const PROGRAM = {
  id: 3,
  displayName: "Programs",
  icon: "fa-light fa-objects-column",
  displayOrder: 3,
  description: "",
};

const templateTypesMap = new Map();
templateTypesMap.set(MENU.id, MENU);
templateTypesMap.set(CATEGORY.id, CATEGORY);
if (process.env.PROGRAMS_ENABLED.toLowerCase() === "true") {
  templateTypesMap.set(PROGRAM.id, PROGRAM);
}

export function getTemplateType(typeId) {
  return templateTypesMap.get(typeId) ?? {};
}

export function getTemplateTypeName(typeId) {
  return templateTypesMap.get(typeId)?.displayName;
}

export const AllTemplateTypes = [...templateTypesMap.values()];

export const UNIVERSAL_MENU_NAME = "Universal Access";


export const CredentialType = {
  CERTIFICATE: 1,
  MICRO_CREDENTIAL: 2,
  BADGE: 3,
};
